import { createSlice } from '@reduxjs/toolkit';

const initialState = { mySubscription: {} };

const mySubscriptionSlice = createSlice({
  name: 'mySubscription',
  initialState,
  reducers: {
    mySubscriptionHandler(state, action) {
      state.mySubscription = action.payload.mySubscriptionData;
    },
  },
});
export const mySubscriptionAction = mySubscriptionSlice.actions;
export default mySubscriptionSlice;